"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Method_1 = __importDefault(require("../Method"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
// import { PaymentMethod } from '@l2p/pay-api'
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var useMethods_1 = require("../useMethods");
var SideBar = function (_a) {
    var _b, _c, _d, _e, _f;
    var selectedMethod = _a.selectedMethod, methods = _a.methods, setMethodSelected = _a.setMethodSelected, type = _a.type, balanceAmount = _a.balanceAmount, currency = _a.currency, isModal = _a.isModal, paymentSettings = _a.paymentSettings;
    var t = (0, next_intl_1.useTranslations)('translation');
    var methodsToShow = (0, useMethods_1.useMethods)({ type: type, methods: methods, paymentSettings: paymentSettings });
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var getMethodIsActive = (0, react_1.useCallback)(function (method, activeMethod) {
        if (!method)
            return false;
        if (method.childMethodId) {
            return method.childMethodId === (activeMethod === null || activeMethod === void 0 ? void 0 : activeMethod.childMethodId);
        }
        return method.name === (activeMethod === null || activeMethod === void 0 ? void 0 : activeMethod.name);
    }, []);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        if (!selectedMethod && methodsToShow) {
            if ((_a = methodsToShow === null || methodsToShow === void 0 ? void 0 : methodsToShow.paymentsWithLabelsSetup) === null || _a === void 0 ? void 0 : _a[0])
                setMethodSelected((_b = methodsToShow === null || methodsToShow === void 0 ? void 0 : methodsToShow.paymentsWithLabelsSetup) === null || _b === void 0 ? void 0 : _b[0]);
            else
                setMethodSelected((_c = methodsToShow === null || methodsToShow === void 0 ? void 0 : methodsToShow.paymentsWithLabelsAdditional) === null || _c === void 0 ? void 0 : _c[0]);
        }
    }, [methodsToShow, setMethodSelected, selectedMethod]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isModal ? styles_module_scss_1.default.modal : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.headerRow, style: { marginBottom: '10px' } },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t(type)),
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.currencyContainer, " ").concat(isModal ? styles_module_scss_1.default.modal : '') },
                    react_1.default.createElement("h5", { className: styles_module_scss_1.default.currency }, currency))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.headerRow },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.headerSubTitle },
                        t('balance'),
                        ":"),
                    Object.keys(breakpoints).length !== 0 && breakpoints.mobile ? (react_1.default.createElement("h4", { className: styles_module_scss_1.default.balanceH4 }, (_b = Number(balanceAmount)) === null || _b === void 0 ? void 0 : _b.toFixed(2))) : (react_1.default.createElement("h1", { className: styles_module_scss_1.default.balanceH1 }, (_c = Number(balanceAmount)) === null || _c === void 0 ? void 0 : _c.toFixed(2)))))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.methodsContainer }, (_d = methodsToShow === null || methodsToShow === void 0 ? void 0 : methodsToShow.paymentsWithLabelsSetup) === null || _d === void 0 ? void 0 :
            _d.map(function (method) {
                var _a;
                if (!(method === null || method === void 0 ? void 0 : method.name))
                    return null;
                var methodConfig = paymentSettings[method === null || method === void 0 ? void 0 : method.id];
                return (react_1.default.createElement(Method_1.default, { key: (method === null || method === void 0 ? void 0 : method.childMethodId) || method.name, name: method.name, label: (_a = method.styles) === null || _a === void 0 ? void 0 : _a.label, method: method, styles: method.styles, onClick: function () {
                        setMethodSelected(method);
                    }, isActive: getMethodIsActive(method, selectedMethod), isDisabled: false, background: methodConfig === null || methodConfig === void 0 ? void 0 : methodConfig.background }));
            }),
            (((methodsToShow === null || methodsToShow === void 0 ? void 0 : methodsToShow.paymentsWithLabelsSetup) &&
                ((_e = methodsToShow === null || methodsToShow === void 0 ? void 0 : methodsToShow.paymentsWithLabelsSetup) === null || _e === void 0 ? void 0 : _e.length) > 0) ||
                ((_f = methodsToShow === null || methodsToShow === void 0 ? void 0 : methodsToShow.paymentsWithLabelsSetup) === null || _f === void 0 ? void 0 : _f.length) === 0) &&
                methodsToShow.paymentsWithLabelsAdditional.map(function (method) {
                    var _a;
                    if (!(method === null || method === void 0 ? void 0 : method.name))
                        return null;
                    var methodConfig = paymentSettings[method === null || method === void 0 ? void 0 : method.id];
                    return (react_1.default.createElement(Method_1.default, { key: (method === null || method === void 0 ? void 0 : method.childMethodId) || method.name, name: method.name, label: (_a = method.styles) === null || _a === void 0 ? void 0 : _a.label, styles: method.styles, method: method, onClick: function () {
                            setMethodSelected(method);
                        }, isActive: getMethodIsActive(method, selectedMethod), isDisabled: false, background: methodConfig === null || methodConfig === void 0 ? void 0 : methodConfig.background }));
                }))));
};
exports.default = SideBar;
